import { MessageOperation } from '@peercolab/engine'
import { UpdateBreedNameInput, MoveBreedInput } from '../../../../../PathItems'

export class RemoveBreed extends MessageOperation<object> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.Breeds.RemoveBreed",
      "REMOVE",
      ["BreedId", "SpeciesId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateBreedName extends MessageOperation<UpdateBreedNameInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.Breeds.UpdateBreedName",
      "PATCH",
      ["BreedId", "SpeciesId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class MoveBreed extends MessageOperation<MoveBreedInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Species.Operations.Server.Breeds.MoveBreed",
      "PATCH",
      ["BreedId", "SpeciesId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

